import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UpdateUserMeRequest {
  name?: string;
  avatar_url?: string;
}

interface UpdateUserMeResponse {
  user: {
    id: string;
    email: string;
    name: string | null;
    avatar_url: string | null;
  };
}

export function useUpdateUserMe() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateUserMeRequest) => {
      const response = await api
        .patch('user/me', { json: data })
        .json<UpdateUserMeResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.me });
    },
  });
}
